// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"586":"3f76237386fc0939","994":"547ecb3d84cf089d"}[chunkId] + ".css";
};